module.exports = __webpack_public_path__ + "img/brands-wasa-logo.png?a113657f54e0cf3d26243aa363980c15";